<template>
  <v-list-item
    v-if="isRailMode"
    min-height="35px"
    :title="t('global.search')"
    @click="openSearch"
  >
    <template #prepend>
      <v-icon
        icon="fas fa-search"
        size="x-small"
      />
    </template>
  </v-list-item>
  <div
    v-else
    class="px-2 py-1"
  >
    <v-autocomplete
      ref="field"
      v-model="selected"
      v-model:search="query"
      :items="results"
      item-title="title"
      item-value="path"
      :label="t('global.search')"
      :loading="isPreparing"
      :no-data-text="t('search.no_results', { query })"
      :hide-no-data="!query"
      density="compact"
      variant="solo-filled"
      menu-icon=""
      no-filter
      hide-details
      clearable
      @focus="prepare"
      @update:model-value="openPage"
    >
      <template #prepend-inner>
        <v-icon
          icon="fas fa-search"
          size="x-small"
        />
      </template>
      <template #item="{ props: itemProps, item }">
        <v-list-item
          v-bind="itemProps"
          :subtitle="item.guide"
        />
      </template>
    </v-autocomplete>
  </div>
</template>

<script setup lang="ts">
import type { HelpSearchResult } from '@/composables/useHelpSearch';
import { computed, nextTick, ref, useTemplateRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useMenu } from '@/composables';
import { useHelpSearch } from '@/composables/useHelpSearch';

const { t } = useI18n();
const router = useRouter();
const { isRailMode, setRailModeOff } = useMenu();
const { prepare, search, isPreparing } = useHelpSearch();

const field = useTemplateRef<{ focus: () => void }>('field');
const query = ref('');
const selected = ref<string | null>(null);

const results = computed<HelpSearchResult[]>(() => search(query.value ?? ''));

async function openPage(path: string | null): Promise<void> {
  if (!path) {
    return;
  }
  await router.push(path);
  selected.value = null;
  query.value = '';
}

async function openSearch(): Promise<void> {
  setRailModeOff();
  await nextTick();
  field.value?.focus();
}
</script>
